import { render, staticRenderFns } from "./raw_user_home.vue?vue&type=template&id=21be29d2&scoped=true"
import script from "./raw_user_home.vue?vue&type=script&lang=js"
export * from "./raw_user_home.vue?vue&type=script&lang=js"
import style0 from "./raw_user_home.vue?vue&type=style&index=0&id=21be29d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21be29d2",
  null
  
)

export default component.exports